import React from "react";
import { impactHighlights } from "../../data/portfolio";

const AboutCard = () => {
  return (
    <div className="about-card glass-panel scroll-reveal">
      <div className="section-kicker">About</div>
      <h1 className="section-title">I turn performance work into product outcomes.</h1>
      <p>
        I do my best work on teams that care about speed, reliability, and measurable impact. Recently that has meant
        rebuilding a storefront for sub-second loads, modernising a production mobile app, instrumenting checkout to
        find where buyers drop off, and building the internal tools stores run on every day.
      </p>
      <div className="about-proof-list">
        {impactHighlights.map((item) => (
          <div className="about-proof" key={item}>
            <span />
            <p>{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutCard;
